export const PROJECTS = [
    {
        id: 'attribution-optimization',
        title: 'Attribution Optimization Platform',
        image: '/assets/project_1_attribution.webp',
        company: 'Fleek',
        companyLogo: '/assets/fleek-yellow-logo.svg',
        tags: ['AdTech', 'Revenue Optimization', 'Performance'],
        metrics: ['+30% Attribution Rate', 'Reduced CAC', 'Optimized Ad Budget'],
        description: 'Increased attribution from 5% to 35%, reducing customer acquisition cost and optimizing ad budget. Implemented comprehensive tracking and analytics to improve ROI.',
    },
    {
        id: 'fancode-video',
        title: 'Video Streaming System Re-architecture',
        image: '/assets/project_2_video.webp',
        company: 'FanCode',
        companyLogo: '/assets/fancode-icon.svg',
        tags: ['Video Streaming', 'Performance', 'Architecture', 'Security'],
        metrics: ['⚡ Faster Start Time', 'Fixed Rebuffering', '99.9% Uptime'],
        description: 'Re-architected video streaming system to improve start time and eliminate rebuffering. Implemented DRM, watermarking, concurrent stream limits, and token authentication.',
    },
    {
        id: 'ad-integration-fancode',
        title: 'Ad Integration & Monetization Platform',
        image: '/assets/project_3_ads.webp',
        company: 'FanCode',
        companyLogo: '/assets/fancode-icon.svg',
        tags: ['AdTech', 'Video Streaming', 'Monetization', 'Integration'],
        metrics: ['Google Ads Integration', 'SSAI/CSAI Support', 'Cast Adapter'],
        description: 'Integrated Google Ads to monetize free content. Implemented SSAI and CSAI using Google IMA. Added Cast Adapter and Receiver Integration for seamless ad experience.',
    },
    {
        id: 'bundle-optimization-ssr',
        title: 'Bundle Optimization & SSR Platform',
        image: '/assets/project_4_bundle.webp',
        company: 'FanCode',
        companyLogo: '/assets/fancode-icon.svg',
        tags: ['Performance', 'DevOps', 'CI/CD', 'Optimization'],
        metrics: ['Improved First Load', 'Bundle Size Tracking', 'SSR Enabled'],
        description: 'Implemented bundle splitting and size optimization to improve first load time. Built SSR for better SEO. Created automated CI/CD pipeline with GitHub Actions and Bundle Size Tracker Dashboard.',
    },
    {
        id: 'fashion-revamp',
        title: 'Fashion Experience Revamp',
        image: '/assets/project_5_fashion.webp',
        company: 'Flipkart',
        companyLogo: '/assets/flipkart-icon.svg',
        tags: ['E-commerce', 'UX', 'Performance', 'Business Impact'],
        metrics: ['+3.52% Engagement', 'Improved Conversion', 'Mobile First'],
        description: 'Led fashion shopping experience revamp on Flipkart, resulting in 3.52% increase in user engagement. Focused on mobile-first design and performance optimization.',
    },
    {
        id: 'rn-web-migration',
        title: 'React Native for Web Migration',
        image: '/assets/project_6_rnw.webp',
        company: 'Flipkart',
        companyLogo: '/assets/flipkart-icon.svg',
        tags: ['Cross-platform', 'Code Reuse', 'React Native', 'Performance'],
        metrics: ['Reduced Dev Time', 'Common Codebase', 'Faster Feature Delivery'],
        description: 'Migrated React and React Native apps to React Native for Web, creating a unified codebase. Reduced development time while maintaining consistent user experience.',
    },
];
